import api from "@/lib/api";

export const enterpriseService = {
  contact: (payload) => api.post("/enterprise/contact", payload).then((r) => r.data),
};
